import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-02/lesson-12/task-04";

const task: Slide = {
  title: "For which of the mentioned options are ITD and ILD most relevant?",
  description: "Select all true statements.",
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colSpan: {
        "1:0": 2,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "ITD",
                  formatter: "simple",
                  scrollbars: false,
                  styles: {
                    fontSize: "20px",
                    fontWeight: 700,
                    lineHeight: "24px",
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "ILD",
                  formatter: "simple",
                  scrollbars: false,
                  styles: {
                    fontSize: "20px",
                    fontWeight: 700,
                    lineHeight: "24px",
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task04.id,
            },
          },
        ],
        [],
      ],
    },
  },
};

export default task;
